import { withIfUser } from '@app/components/common/Routes';
import { hasPermissions } from '@app/utils';
import MatrixReport2 from '@app/views/Ledger/MatrixReport2';
import { memo } from 'react';

export default memo(
  withIfUser(MatrixReport2)({
    condition: ({ roles }) => roles.some(hasPermissions),
    redirect: true,
    redirectTo: '/unauthorized',
  })
);
